<template>
    <nut-cell :title="value.toString()" center>
        <template v-slot:link>
            <span style="color: #8c8c8c">度/秒 (°/s)</span>
        </template>
    </nut-cell>
    <div id="rot-y-chart" style="width: 100%; height: 240px"></div>
</template>

<script>
export default {
    name: "RotY",
    data() {
        return {
            chartData: [],
            value: 0
        }
    },
    mounted() {
        const echarts = this.$echarts;

        const chart = echarts.init(document.getElementById('rot-y-chart'));
        chart.setOption({
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                }
            },
            legend: {
                data: ['Y轴旋转速率']
            },
            toolbox: {
                feature: {
                    dataView: {}
                }
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: false,
                    show: false,
                    data: []
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    min: (value) => {
                        return (Math.abs(value.min) < value.max ? -value.max * 1.05 : value.min * 1.05).toFixed(2);
                    },
                    max: (value) => {
                        return (Math.abs(value.min) < value.max ? value.max * 1.05 : -value.min * 1.05).toFixed(2);
                    }
                }
            ],
            series: [
                {
                    name: 'Y轴旋转速率',
                    type: 'line',
                    stack: 'Total',
                    smooth: true,
                    lineStyle: {
                        width: 0
                    },
                    showSymbol: false,
                    areaStyle: {
                        opacity: 0.8,
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: 'rgb(255, 0, 135)'
                            },
                            {
                                offset: 1,
                                color: 'rgb(135, 0, 157)'
                            }
                        ])
                    },
                    emphasis: {
                        focus: 'series'
                    },
                    data: []
                }
            ]
        });

        const data = this.chartData;
        const unwatchRotY = this.$watch('$store.state.rot_y', function (n) {
            if (n !== null) {
                this.value = n;
                if (data.length < 28) {
                    data.push([new Date().getTime(), n]);
                } else {
                    data.shift();
                    data.push([new Date().getTime(), n]);
                }

                const x = [];
                for (const i in data) {
                    x.push(data[i][0]);
                }

                const y = [];
                for (const i in data) {
                    y.push(data[i][1]);
                }

                chart.setOption({
                    xAxis: {
                        data: x
                    },
                    series: [
                        {
                            data: y
                        }
                    ]
                });
            }
        });
    },
}
</script>